import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';

import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { AnalyticsUiModule } from '@cigna/analytics/ui';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';

import { UiInputModule } from '@cigna/ui/input';
import { UiButtonModule } from '@cigna/ui/button';
import { UiIconModule } from '@cigna/ui/icon';
import { UiProgressModule } from '@cigna/ui/progress';
import { UiCollapsibleModule } from '@cigna/ui/collapsible';
import { UiModalModule } from '@cigna/ui/modal';

import { DialogSiteHelpPublicComponent } from './dialog-site-help-public/dialog-site-help-public.component';
import { DialogSiteHelpSecureComponent } from './dialog-site-help-secure/dialog-site-help-secure.component';
import { DialogLegalDisclaimerComponent } from './dialog-legal-disclaimer/dialog-legal-disclaimer.component';
import { DialogSiteTourComponent } from './dialog-site-tour/dialog-site-tour.component';
import { DialogPrivacyComponent } from './dialog-privacy/dialog-privacy.component';
import { ResourcesSearchFormComponent } from './resources-search-form/resources-search-form.component';
import { HeaderLogoComponent } from './header-logo/header-logo.component';
import { HeaderUserUtilComponent } from './header-user-util/header-user-util.component';
import { PrimaryNavComponent } from './primary-nav/primary-nav.component';
import { NavLinksComponent } from './nav-links/nav-links.component';
import { UnavailableComponent } from './unavailable/unavailable.component';
import { HeaderComponent } from './header/header.component';
import { FooterGlobalComponent } from './footer-global/footer-global.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { NavItemComponent } from './nav-item/nav-item.component';
import { AlertsComponent } from './alerts/alerts.component';
import { DevToggleComponent } from './dev-toggle/dev-toggle.component';
import { UndevelopedPageComponent } from './undeveloped-page/undeveloped-page.component';
import { PasswordChangeBannerComponent } from './password-change-banner/password-change-banner.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { TrustComponent } from './trust/trust.component';
import { DialogProviderRelationsComponent } from './dialog-provider-relations/dialog-provider-relations.component';
import { DialogSecureAlertComponent } from './dialog-secure-alert/dialog-secure-alert.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    ChcpSharedUiModule,
    RouterModule,
    UiInputModule,
    UiButtonModule,
    UiIconModule,
    UiProgressModule,
    UiModalModule,
    UiCollapsibleModule,
    AnalyticsUiModule,
    ChcpSharedEnvironmentUtilModule,
  ],
  declarations: [
    DialogSiteHelpPublicComponent,
    DialogSiteHelpSecureComponent,
    DialogLegalDisclaimerComponent,
    DialogSiteTourComponent,
    DialogPrivacyComponent,
    DialogProviderRelationsComponent,
    ResourcesSearchFormComponent,
    HeaderLogoComponent,
    HeaderUserUtilComponent,
    PrimaryNavComponent,
    NavLinksComponent,
    UnavailableComponent,
    HeaderComponent,
    FooterGlobalComponent,
    BreadcrumbsComponent,
    NavItemComponent,
    AlertsComponent,
    UndevelopedPageComponent,
    DevToggleComponent,
    PasswordChangeBannerComponent,
    NotFoundComponent,
    TrustComponent,
    DialogSecureAlertComponent,
  ],
  exports: [
    ResourcesSearchFormComponent,
    HeaderLogoComponent,
    HeaderUserUtilComponent,
    PrimaryNavComponent,
    NavLinksComponent,
    NavItemComponent,
    UnavailableComponent,
    HeaderComponent,
    FooterGlobalComponent,
    BreadcrumbsComponent,
    AlertsComponent,
    UndevelopedPageComponent,
    DevToggleComponent,
    PasswordChangeBannerComponent,
    NotFoundComponent,
    TrustComponent,
    DialogProviderRelationsComponent,
    DialogSecureAlertComponent,
    DialogLegalDisclaimerComponent,
    DialogPrivacyComponent,
    DialogSiteHelpPublicComponent,
    DialogSiteHelpSecureComponent,
    DialogSiteTourComponent,
  ],
})
export class ChcpShellUiModule {}
